import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgAccessible32 = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 23,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10.79v2.126a5.001 5.001 0 1 0 6.584 6.584l2.126.001A7 7 0 1 1 5 10.79Zm4.726-3.467.12.108 3.069 3.069H17v2h-4.914L9 9.415v5.752c0 .16.114.295.266.326l.067.007h5.581L20 20.585l1.5-1.5 1.414 1.415L20 23.414 14.085 17.5H9.333a2.333 2.333 0 0 1-2.328-2.174L7 15.166V8.61a1.667 1.667 0 0 1 2.726-1.286ZM9 .5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z",
    fill: props.color || "#007FAB"
  })
}));
export default SvgAccessible32;